module.exports = new __parcel__URL__("lightbulb-orbit.353743a0.svg").toString();